import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import styles from './header-cell.scss';

const HeaderCell = ({ onClick, name, children, className, ...props }) => {
  const renderColumnName = () => {
    if (name) {
      return (
        <span className={`${styles.columnName} label`} onClick={onClick}>
          {name}
        </span>
      );
    }

    return <span />;
  };

  return (
    <th className={classNames(className, styles.headerCell)} scope="col" {...props}>
      {renderColumnName()}
      {children}
    </th>
  );
};

HeaderCell.propTypes = {
  name: PropTypes.string,
  cssClass: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default observer(HeaderCell);
